(function (angular) {
    "use strict";

    function drv() {
        return {
            restrict: "E",
            scope: {
                model: "<spModel",
                isShowTop: "<?spShowTop",
            },
            templateUrl: "views/templates/sp-mobile-carousel.html",
            controllerAs: "mobileCarouselCtrl",
            controller: ["$scope", "$window", "Util", ctrl],
        };
    }

    function ctrl($scope, $window, Util) {
        var mobileCarouselCtrl = this,
            _listeners = [];
        mobileCarouselCtrl.carousels = [];
        mobileCarouselCtrl.MIN_SHORT_CUTS_DISPLAY = 4;
        _listeners.push($scope.$watch("model", _syncData, true));

        function _syncData(newModel) {
            if (!newModel || newModel.length === 0) {
                return [];
            }

            mobileCarouselCtrl.carousels = [];
            for (var i = 0; i < newModel.length; i++) {
                var shortcut = newModel[i];
                if (!shortcut || !shortcut.data) {
                    continue;
                }

                // Show shortcut if isShowTop matches isPlaceOnTop 
                // — i.e., meant to appear in the current section (replace top navigation buttons or below banners)
                var shouldShow = ($scope.isShowTop && shortcut.data.isPlaceOnTop) || (!$scope.isShowTop && !shortcut.data.isPlaceOnTop);
                if (shouldShow) {
                    mobileCarouselCtrl.carousels.push(shortcut.data);
                }
            }
        }

        Util.destroyListeners($scope, _listeners);
    }

    angular.module("mobilezuz").directive("spMobileCarousel", drv);
})(angular);

